import api from '../../api/client';
import React from "react";
import PurchaseInvoiceForm from "../../components/PurchaseInvoiceForm";

function Assets() {
  return (
    <>
      <PurchaseInvoiceForm onSuccess={() => {}} />
    </>
  );
}

export default Assets;
